import { render, staticRenderFns } from "./CreateMyReceiveInterDocu.vue?vue&type=template&id=2e2cbe4a&scoped=true&"
import script from "./CreateMyReceiveInterDocu.vue?vue&type=script&lang=js&"
export * from "./CreateMyReceiveInterDocu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2cbe4a",
  null
  
)

export default component.exports